import { use } from 'react';
import { loadEditorDependencies } from 'AssetLoader';

let editorDependenciesPromise: Promise<void> | null = null;

function getGlobalEditorDependenciesPromise(): Promise<void> {
    if (!editorDependenciesPromise) {
        editorDependenciesPromise = loadEditorDependencies();
    }
    return editorDependenciesPromise;
}

/**
 * Suspense-enabled hook to load editor dependencies using React 19's `use` hook.
 * Pure JavaScript implementation without Angular dependencies.
 *
 * This hook will suspend (throw a promise) while dependencies are loading,
 * which requires the component to be wrapped in a <Suspense> boundary.
 *
 * Note: This hook only handles asset loading, not permission checking.
 * Permission checking should be done at the route level via ProtectedRoute.
 *
 * @throws {Promise<void>} When dependencies are still loading (suspends)
 * @throws {Error} When dependency loading fails
 */
export function useLoadEditorDependencies(): void {
    // React 19's `use` hook handles the suspense automatically
    use(getGlobalEditorDependenciesPromise());
}
